import { Component, OnInit } from '@angular/core';
import { ChartDataSets } from 'chart.js';
import { AuthService } from 'src/app/servicios/auth.service';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-auditorias',
  templateUrl: './auditorias.component.html',
  styleUrls: ['./auditorias.component.scss']
})
export class AuditoriasComponent implements OnInit {


  public barChartOptions: any = {
    responsive: true,
    scaleSownVerticalLines:false
  } ;

  public barChartOptions2: any = {
    responsive: true,
    scaleSownVerticalLines:false
  } ;

  public barChartLabels: string[] = [];// ['About', 'Curso Git', 'Bartenders', 'Cocineros','reposteros',"asd","asd","d"];
  public barChartType: string = 'bar';
  public barChartLegend = true;
  public barChartData:ChartDataSets[];
  public arry = [];


  public barChartLabels2: string[] = [];// ['About', 'Curso Git', 'Bartenders', 'Cocineros','reposteros',"asd","asd","d"];
  public barChartType2: string = 'pie';
  public barChartLegend2 = true;
  public barChartData2:ChartDataSets[];
  public arry2 = [];

  constructor(private autSvc:AuthService, private db:AngularFirestore) { }

  ngOnInit(): void {
    
    this.db.collection("cursos").get().subscribe(res=>
      {
        res.forEach((doc)=>
        {
          let nombre = doc.data().titulo;
          let data = doc.data().vistas;
          //console.log(data);


          this.barChartLabels.push(nombre)
          this.arry.push(data)
          
        
          this.barChartLabels2.push(nombre)
          this.arry2.push(data)
          
        })
      })
    


    console.log(this.arry);
    
    this.barChartData = [{data:this.arry}]
      
    this.barChartData2 = [{data:this.arry2}]

      
  }

}
